import React from "react";
import "./promoanniv.scss";
import Comingsoon from "../../Media/Hardsell_Desktop.webp";
import Soon from "../../Media/Hardsell_Mobile.webp";

const soon = () => {
  return (
    <div id="promo" className="container-soon">
      <div className="louise">
        <h1>Promo Special Anniversary Summarecon</h1>
      </div>
      <div className="maps-lokasi">
        <img className="img-lokasi-dekstop" src={Comingsoon} alt="maps" />
        <img className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <p className="promo-disclaimer">
        Informasi properti harga, spesifikasi, dan ketersediaan unit dapat
        berubah sewaktu-waktu, silahkan hubungi kamu untuk informasi terbaru
      </p>
    </div>
  );
};

export default soon;
